import { render, staticRenderFns } from "./Business.vue?vue&type=template&id=1faff1d4&scoped=true&"
import script from "./Business.vue?vue&type=script&setup=true&lang=js&"
export * from "./Business.vue?vue&type=script&setup=true&lang=js&"
import style0 from "./Business.vue?vue&type=style&index=0&id=1faff1d4&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1faff1d4",
  null
  
)

export default component.exports